import * as React from 'react'
import { connect, ConnectedProps } from 'react-redux'
import {
  Location,
  NavigateFunction,
  useNavigate,
  useParams,
} from 'react-router-dom'

import * as PlaylistShareActions from '@disco/state-management/actions/PlaylistShareActions'
import * as ShortlistActions from '@disco/state-management/actions/ShortlistActions'
import { getPlaylist } from '@disco/state-management/selectors/playlists'
import { getPlaylistSharesWithContacts } from '@disco/state-management/selectors/shares'

import DocumentHeadTags from 'components/document-head-tags'
import SendPlaylistConfirmation from 'components/modals/playlist/send'

const mapStateToProps = (state, { playlistId }) => {
  return {
    playlist: getPlaylist(state, {
      id: parseInt(playlistId, 10),
    }),
    shares: getPlaylistSharesWithContacts(state),
    user: state.user,
  }
}

const mapDispatchToProps = {
  ...ShortlistActions,
  ...PlaylistShareActions,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
  navigate: NavigateFunction
  location: Location
  params: {
    playlistId: string
    shareId: string
  }
}

class PlaylistShared extends React.Component<Props> {
  checkParams(props, params) {
    // check if params are valid to prevent futher errors and state corruption
    const { playlist } = props
    const share = props.shares[params.shareId]
    if (!playlist || !share) this._closeModal()
  }

  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    this.checkParams(nextProps, this.props.params)
  }

  _closeModal = () => this.props.navigate('/')
  _shareAgain = () => {
    const { playlistId } = this.props.params
    const path = `/explorer/playlists/${playlistId}/share`
    this.props.navigate(path)
  }

  render() {
    const { playlistId, shareId } = this.props.params
    const { playlist } = this.props
    const share = this.props.shares[shareId]
    if (!playlist || !share) return null
    const { recipients } = share
    return (
      <div>
        <DocumentHeadTags title="Playlist sent | DISCO" />
        <SendPlaylistConfirmation
          {...this.props}
          recipients={recipients}
          newEmailGroupRoute={`/explorer/playlists/${playlistId}/shared/${shareId}/create-email-group`}
          onClose={this._closeModal}
          onShareAgain={this._shareAgain}
        />
      </div>
    )
  }
}

const ConnectedPlaylistShared = connector(PlaylistShared)

function PlaylistSharedWithNavigate(props) {
  const navigate = useNavigate()
  const { playlistId, shareId } =
    useParams<{ playlistId: string; shareId: string }>()
  return (
    <ConnectedPlaylistShared
      {...props}
      navigate={navigate}
      params={{ playlistId, shareId }}
      playlistId={playlistId}
    />
  )
}

export default PlaylistSharedWithNavigate
